import React from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

const HistoricalError = ({ content }) => {
  const { screens, routes } = content;
  const [screen] = screens;
  const buttonConfig = {
    left: {
      destination: routes.left
    },
    right: {
      destination: routes.right
    }
  };

  return [
    <Display key="display">
      <Header>
        <HeaderText value={screen.title} />
      </Header>
      <Content>
        <Labels values={screen.data} />
      </Content>
      <Footer>
        <DisplayButton src="icon-xm-left-arrow" />
        <DisplayButton src="icon-xm-cycle" />
        <DisplayButton src="icon-xm-right-arrow" />
      </Footer>
    </Display>,
    <HardwareButtonWrapper key="buttons" config={buttonConfig} />
  ];
};

HistoricalError.propTypes = {
  content: PropTypes.shape({
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

export default HistoricalError;



// WEBPACK FOOTER //
// ./src/screens/shared/Settings/HistoricalError/HistoricalError.js